import { ViewEncapsulation } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/auth/authentication.service';
import { CustomMessageService } from '@app/custom-message/custom-message.service';
import { LoggerService } from '../logger/logger.service';
import { HomeService } from './home.service';
import { NavigationService } from '../navigation/navigation.service';
import { MediaObserver } from '@angular/flex-layout';



const log = new LoggerService('HOME COMPONENT');

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,

})
export class HomeComponent implements OnInit {

  urls = {
    dohealth: 'https://www.dohealth.com.mx/'
  }

  images = {
    triangles: 'https://epione-image.s3.us-east-2.amazonaws.com/epione/background_red_triangles.png',
    logo_epione: 'https://epione-image.s3.us-east-2.amazonaws.com/epione/logo_epione_colors_shadow.png',
    banner: 'https://epione-image.s3.us-east-2.amazonaws.com/epione/doctor_text.jpg',
    dohealth: 'https://epione-image.s3.us-east-2.amazonaws.com/epione/logo_dohealth_colors.png',
  }
  noMostrar=[];

  viewloading = false;
  homeUiNavRoutes: Components.HomeComponent.HomeUiNavData[] = [];

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private homeService: HomeService,
    private customMessageService: CustomMessageService,
    private media: MediaObserver,
    private navigationService: NavigationService
  ) { }

  async ngOnInit() {
    await this.generateHomeUiNav();
    this.navigateToHomeToMain();
    console.log(this.homeUiNavRoutes);
  }


  get isMobile(): boolean {
    return this.media.isActive('xs') || this.media.isActive('sm') || this.media.isActive('sm');
  }


  /**
   * @description Redirecciona a home main en el caso de que la ruta home no tenga una subruta.
   */
  private navigateToHomeToMain() {
    if (location.pathname === '/home')
      this.router.navigate(['/home/main']);
  }

  /**
   * @description Genera la barra de navegación de home con las rutas correspondientes.
   */
  public async generateHomeUiNav() {
    try {
      this.viewloading = true;
      //this.customMessageService.open({type: 'success', message:'Cargando el sistema epione', duration:1000});
      const apiResponse = await this.homeService.getHomeNavigationData();


      if (apiResponse.state === 'success') {
        //log.debug('Api response data: ', apiResponse.data);
        const homeData = apiResponse.data[0];

        const navDataRoutes = this.navigationService.generateNavigationDataRoutesFromToolsArray(homeData.remoteEntry, homeData.exposedModule, homeData.tools);
        this.homeUiNavRoutes = navDataRoutes.map((navDataRoute) => {
          return {
            navigationDataRoute: navDataRoute,
            hasChildren: (navDataRoute.children.length > 0)
          }
        });

        log.debug('[generateHomeUiNav] homeUiNavRoutes: ', this.homeUiNavRoutes);


        this.viewloading = false;
      }

      if (apiResponse.state === 'error') {
        throw new Error(apiResponse.message);
      }

    } catch (err) {
      this.viewloading = false;
      this.customMessageService.open({ type: 'error', message: err.message, duration: 2000 });
      throw err;
    }
  }

  /**
   * @description Redirecciona al login si el usuario no cuenta con una sesión activa en el navegador. Si la sesión existe lo redirecciona a la plataforma epione.
   */
  public async goToLogIn() {
    const userAlreadyLoggedIn = await this.authenticationService.isLoggedIn();
    if (userAlreadyLoggedIn) {
      //log.info('[goToLogIn] El usuario tiene una sesión activa.');
      this.router.navigate(['/']);
    } else {
      //log.info('[goToLogIn] Sesión del usuario no encontrada, redireccionando al login.')
      this.router.navigate(['/home/login']);
    }
  }

  /**
   * @description Redirecciona a la ruta seleccionada de home. Las rutas de home no necesitan de una sesión iniciada.
   */
  public async goToRoute(path: string) {
    log.debug('[goToRoute] Home route clicked, Path:', path);
    this.router.navigate([`/home/${path}`]);
  }

  /**
   * @description Redirecciona a la subruta seleccionada de home. Las rutas de home no necesitan de una sesión iniciada.
   */
  public async goToSubRoute(path: string, subpath: string) {
    console.log(subpath);
    this.router.navigate([`/home/${path}/${subpath}`]);

  }


  /**
   * @description Redirecciona a la pagina de dohealth.
   */
  public goToDohealth() {
    location.replace(this.urls.dohealth);
  }

}
